import { ThemeProps } from "@rjsf/core";
import { StringWidget } from "./StringWidget";
import { TextAreaWidget } from "./TextAreaWidget";
import { SelectWidget } from "./SelectWidget";
import { CheckboxWidget } from "./CheckboxWidget";
import { RadioWidget } from "./RadioWidget";
import { DateWidget } from "./DateWidget";
import { DateTimeWidget } from "./DatetimeWidget";
import { EmailWidget } from "./EmailWidget";
import { URLWidget } from "./URLWidget";
import { NumberWidget } from "./NumberWidget";
import { IntegerWidget } from "./IntegerWidget";
import { PasswordWidget } from "./PasswordWidget";
import { BooleanWidget } from "./BooleanWidget";
import { ToggleWidget } from "./ToggleWidget";
import { CustomFieldTemplate } from "./Templates/FieldTemplate";
import { CustomLabelTemplate } from "./Templates/LabelTemplate";
import { CustomObjectFieldTemplate } from "./Templates/ObjectFieldTemplate";
import { CustomTitleFieldTemplate } from "./Templates/CustomTitleFieldTemplate";
import { CustomButtonTemplate } from "./Templates/ButtonTemplate";
import ImageWidget from "./ImageWidget";

export const widgetDefinition: ThemeProps = {
  widgets: {
    TextWidget: StringWidget,
    TextAreaWidget: TextAreaWidget,
    SelectWidget: SelectWidget,
    CheckboxWidget: CheckboxWidget,
    RadioWidget: RadioWidget,
    DateWidget: DateWidget,
    DateTimeWidget: DateTimeWidget,
    EmailWidget: EmailWidget,
    URLWidget: URLWidget,
    NumberWidget: NumberWidget,
    IntegerWidget: IntegerWidget,
    PasswordWidget: PasswordWidget,
    BooleanWidget: BooleanWidget,
    ToggleWidget: ToggleWidget,
    ImageWidget: ImageWidget,
  },
  // Custom templates for labels and containers
  templates: {
    FieldTemplate: CustomFieldTemplate,
    ObjectFieldTemplate: CustomObjectFieldTemplate,
    LabelTemplate: CustomLabelTemplate,
    TitleFieldTemplate: CustomTitleFieldTemplate,
    ButtonTemplates: {
      SubmitButton: CustomButtonTemplate,
    },
  },
};
